import { createSlice } from "@reduxjs/toolkit";
import {
  createComment,
  updateComment,
  deleteComment,
  getAllCommentsAdmin,
} from "./thunk";

const initialState = {
  comments: [],
  loading: false,
  error: null,
};

const commentSlice = createSlice({
  name: "comment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ========================
      // CREATE COMMENT
      // ========================
      .addCase(createComment.pending, (state) => {
        state.loading = true;
      })
      .addCase(createComment.fulfilled, (state, action) => {
        state.loading = false;
        state.comments.unshift(action.payload);
      })
      .addCase(createComment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ========================
      // UPDATE COMMENT
      // ========================
      .addCase(updateComment.fulfilled, (state, action) => {
        const index = state.comments.findIndex(
          (c) => c.id === action.payload.id,
        );
        if (index !== -1) {
          state.comments[index] = action.payload;
        }
      })

      // ========================
      // DELETE COMMENT
      // ========================
      .addCase(deleteComment.fulfilled, (state, action) => {
        state.comments = state.comments.filter((c) => c.id !== action.payload);
      })

      // ========================
      // ADMIN – GET ALL COMMENTS
      // ========================
      .addCase(getAllCommentsAdmin.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllCommentsAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.comments = action.payload;
      })
      .addCase(getAllCommentsAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default commentSlice.reducer;
